export default __webpack_public_path__ + "static/media/121.b7b06903.png";